import classes from './Avatar.module.css';

interface AvatarProps {
  initials: string;
  /** Yellow fill marks the signed-in person; others are neutral surface-2. */
  me?: boolean;
  size?: 32 | 36 | 40 | 44 | 72;
}

/** Initials-only avatar (no photos, per the design system). */
export function Avatar({ initials, me = false, size = 36 }: AvatarProps) {
  const fontSize = size >= 72 ? 24 : size >= 44 ? 14 : 12;
  return (
    <span
      className={classes.root}
      data-me={me || undefined}
      style={{ width: size, height: size, fontSize }}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
}
